<template>
  <div :id="page_slug">
    <div class="crumbs-bar">
      <el-row>
        <el-col :span="12">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ name: 'DashboardPage' }">Dashboard</el-breadcrumb-item>
            <el-breadcrumb-item>Category Groups</el-breadcrumb-item>
          </el-breadcrumb>        
        </el-col>      
      </el-row>
    </div>

    <div class="actions-bar">
      <el-row>
        <el-col :span="8">
          <el-input placeholder="Search By Name" v-on:keyup.native="whichSearchFunctionToUse" v-model="search_terms">
            <template slot="append"><el-button slot="append" icon="el-icon-search"></el-button></template>
          </el-input>
        </el-col>

        <el-col :span="14" :offset="2" class="text-right">
          <el-dropdown trigger="click" :hide-on-click="false">
            <el-tooltip class="item" effect="light" content="Show or hide columns" placement="top">
              <el-button>
                Columns <i class="el-icon-caret-bottom"></i>
              </el-button>
            </el-tooltip>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(column, index) in columns" :key="index">
                <el-checkbox v-model="columns[index]">{{index | prettyIndexName}}</el-checkbox>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <router-link :to="{ name: 'CategoryGroupAdd' }">
            <el-button :disabled="!hasRole('category_groups.can_add')" type="default">Add Category Group</el-button>
          </router-link>
        </el-col>
      </el-row>
    </div>

    <el-row>
      <el-table
        v-loading="loading"
        :data="category_groups"
        border
        resizable="true"
        style="width: 100%">

        <el-table-column
          align="center"
          width="115%">
          <template slot-scope="scope">
            <img :src="scope.row.thumbnail_url" class="template-thumb"/>
          </template>
        </el-table-column>

        <el-table-column
          v-if="columns.id"
          width="115%"
          prop="id"
          label="ID">
        </el-table-column>

        <el-table-column
          v-if="columns.name"
          prop="name"
          label="Name">
        </el-table-column>

        <el-table-column
          v-if="columns.sort_order"
          prop="sort_order"
          label="Sort Order">
        </el-table-column>

        <el-table-column
          v-if="columns.created_at"
          align="center"
          width="115%"
          prop="created_at"
          label="Created Date">
          <template slot-scope="scope">
            {{scope.row.created_at | moment(config.date_format_compact)}}
          </template>          
        </el-table-column>

        <el-table-column
          v-if="columns.updated_at"
          align="center"
          width="115%"
          prop="updated_at"
          label="Updated Date">
          <template slot-scope="scope">
            {{scope.row.updated_at | moment(config.date_format_compact)}}
          </template>          
        </el-table-column>

        <el-table-column
          label="Actions"
          align="center"
          width="115%">
          <template slot-scope="scope">
            <router-link :to="{ name: 'CategoryGroupEdit', params: { id: scope.row.id }}">
              <el-button 
              :disabled="!hasRole('category_groups.can_edit')"
              icon="el-icon-edit"
              type="default" 
              size="small"></el-button>
            </router-link>

            <el-button 
              :disabled="!hasRole('category_groups.can_delete')"
              icon="el-icon-delete" 
              type="default" 
              size="small"
              @click="deleteCategoryGroup(scope.row.id)">
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>

    <el-row :gutter="0">
      <el-col :span="24" :xs="24" :sm="24" class="pagination">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page.sync="pagination.current_page"
          :page-count="pagination.total_pages"
          :page-size="pagination.per_page"
          layout="total, prev, pager, next"
          :total="pagination.total">
        </el-pagination>
      </el-col>
    </el-row>

    <pre>{{$data}}</pre>

  </div>
</template>

<style scoped>

.template-thumb{
  width:50px;
  height:auto;
}

</style>

<script>
  import Config from '@/store/Config.js';
  import Tables from '@/store/Tables.js';
  import store from '@/store/Store.js';

  export default {
    data: function() {
      return {
        page_alias: 'Product Category Group List',
        page_slug: 'product-category-group-list',

        permissions: store.permissions,
        config: Config.config,
        columns: Tables.product_category_groups.columns,
        order_by: Tables.product_category_groups.order_by,
        sort_by: Tables.product_category_groups.sort_by,
        
        loading: false,
        search_terms: '',
        category_groups: [],

        pagination: {
          total: 0,
          per_page: 0,
          current_page: 0,
          last_page: 0,
          next_page_url: '',
          prev_page_url: '',
          from: 0,
          to: 0,
        }
      };
    },

    mounted: function() {
      const me = this;
      me.getCategoryGroups();
    },

    methods: {
      hasRole: function(role_name) {
        const me = this;

        if(me.permissions.user_roles.length > 0) {
          /* returns undefined if doesn't find the role */
          var role = _.find(me.permissions.user_roles, function(o) { 
            return o.name == role_name; 
          });

          /* doesn't enter if when undefined */
          if(role) {
            return true
          }
        }
        
        return false;
      },

      whichSearchFunctionToUse: function() {
        const me = this;

        if(me.search_terms == '') {
          me.getCategoryGroups();
        } else me.searchCategoryGroups();
      },

      getCategoryGroups: function(goToPage) {
        console.log('Get Category Groups Function');
        const me = this;

        me.loading = true;

        me.$http.get(me.config.api + 'category-group', {params: {page: goToPage}}).then(
          response => {
          console.log('Get Category Groups Function - Success Getting Data')  

          me.category_groups = response.body.data;
          
          me.handlePagination(response);

          me.loading = false;
        }, response => {
          console.log('Get Category Groups Function - Error Getting Data');

          me.$notify({
            title: 'Error',
            message: response.statusText,
            type: 'error'
          });

          me.loading = false;
        });
      },

      searchCategoryGroups: function(goToPage) {
        console.log('Search Category Groups Function');
        const me = this;
        me.loading = true;

        me.$http.get(me.config.api + 'category-group', {params: {search_terms: me.search_terms, page: goToPage, sort_by: me.sort_by_field_name, order: me.sort_by_order}}).then(
          response => {
          console.log('Search Category Groups Function - Success Getting Data')  
          
          me.category_groups = response.body.data;

          me.handlePagination(response);
         
          me.loading = false;
        }, response => {
          console.log('Search Category Groups Function - Error Getting Data');

          me.$notify({
            title: 'Error',
            message: response.statusText,
            type: 'error'
          });

          me.loading = false;
        });
      },
      
      deleteCategoryGroup: function(id) {
        console.log('Delete Category Group Function');
        const me = this;

        me.$confirm('This will permanently delete the Category Group - Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          me.loading = true;

          me.$http.delete(me.config.api + 'category-group/{id}', {params: {id : id}}).then(
            response => {
            console.log('Delete Category Group Function - Success Deleting Data')  

            me.getCategoryGroups();

            me.$notify({
              title: 'Success',
              message: 'The Category Group Was Deleted',
              type: 'success',
            });
          }, response => {
            console.log('Delete Category Group Function - Error Deleting Data');

            me.loading = false;
          });  
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete Canceled'
          });  
        });
      },

      handlePagination: function(response) {
        const me = this;

        me.pagination.total = response.body.total;
        me.pagination.per_page = response.body.per_page;
        me.pagination.current_page = response.body.current_page;
        me.pagination.last_page = response.body.last_page;
        me.pagination.next_page_url = response.body.next_page_url;
        me.pagination.prev_page_url = response.body.prev_page_url;
        me.pagination.from = response.body.from;
        me.pagination.to = response.body.to;
			},

      handleCurrentChange(val) {
        const me = this;

        if(me.search_terms == '') {
          me.getProducts(val);
        } else {
          me.searchCategoryGroups(val);
        }

        window.scrollTo(0, 0);
      },
    }, 

    filters: {
      prettyIndexName(text) {
        var prettyName = text.replace(/_/g, ' ').toUpperCase();
        return prettyName
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/product-category-groups/CategoryGroupList.vue